import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Search, Loader2 } from "lucide-react";
import { Nav } from "../components/Nav";
import { toast } from "sonner";
import { PageFooter } from "../components/PageFooter";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Reservations = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState(null);

  const lookup = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/reservations`, {
        params: { email },
      });
      setItems(data.reservations || []);
    } catch {
      toast.error("Could not load reservations");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white text-[var(--kb-fg)]">
      <Nav />
      <main className="pt-32 px-5 sm:px-10 lg:px-14 max-w-3xl mx-auto pb-24">
        <div className="kb-mono-label kb-blue">03 · My Bag</div>
        <h1 className="font-serif text-5xl mt-2 tracking-tight">Your reservations</h1>
        <p className="text-[var(--kb-fg-2)] mt-3 font-light max-w-md">
          Enter the email used at checkout to see your reserved KISUBIKA bags.
        </p>

        <form
          onSubmit={lookup}
          data-testid="reservations-form"
          className="mt-8 flex gap-2 border border-[var(--kb-fg)]"
        >
          <input
            data-testid="reservations-email"
            className="kb-input !border-0"
            placeholder="you@example.com"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            data-testid="reservations-submit"
            disabled={loading}
            className="kb-btn-primary !rounded-none border-none px-5"
          >
            {loading ? <Loader2 size={14} className="animate-spin" /> : <Search size={14} />}
          </button>
        </form>

        <div className="mt-10 space-y-3">
          {items?.length === 0 && (
            <div data-testid="reservations-empty" className="border border-[var(--kb-border)] p-6 text-[var(--kb-fg-2)]">
              No reservations found for that email.
            </div>
          )}
          {items?.map((r) => (
            <Link
              to={`/r/${r.id}`}
              key={r.id}
              data-testid={`reservation-${r.id}`}
              className="border border-[var(--kb-fg)] p-5 flex items-center justify-between gap-4 flex-wrap hover:bg-[var(--kb-bg-2)] transition-colors"
            >
              <div className="flex items-center gap-4">
                <span
                  className="w-12 h-12 border border-[var(--kb-fg)]"
                  style={{ background: r.color_hex || "#002FA7" }}
                />
                <div>
                  <div className="font-serif text-2xl tracking-tight">
                    {r.color_name}
                  </div>
                  <div className="kb-mono-label text-[var(--kb-fg-2)] mt-1">
                    REF · {r.id.slice(0, 8).toUpperCase()} ·{" "}
                    {new Date(r.created_at).toLocaleDateString()}
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="kb-mono-label kb-blue">
                  {r.payment_status?.toUpperCase()}
                </div>
                <div className="font-serif text-2xl mt-1">
                  £{Number(r.amount).toFixed(2)}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </main>
      <PageFooter />
    </div>
  );
};

export default Reservations;
